import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { Drawer, Icon } from '~/components';
import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';

import { itemStyle, navigationMobileDrawerContentStyle, navigationMobileStyle } from './Layout.css';
import { useNavigationBarItems } from './Navigation.hooks';
import { NavigationMobileDrawer } from './NavigationMobileDrawer';

export const NavigationMobile = () => {
  const barItems = useNavigationBarItems();

  const { t } = useTranslation(['common']);

  const isMobile = useMediaQuery(breakpoints.small);

  if (!isMobile) return null;

  return (
    <nav aria-label={t('common:navigation.shortcuts')} className={navigationMobileStyle}>
      {barItems.map((item) => {
        return (
          <NavLink className={itemStyle} data-pf-id={item.productFruitsId} key={item.label} to={item.to}>
            <Icon name={item.icon} />

            <span>{item.label}</span>
          </NavLink>
        );
      })}

      <Drawer.Root>
        <Drawer.Trigger className={itemStyle}>
          <Icon name="Menu" />

          <span>{t('common:sidebar.more')}</span>
        </Drawer.Trigger>

        <Drawer.Popup>
          <Drawer.Content className={navigationMobileDrawerContentStyle}>
            <NavigationMobileDrawer />
          </Drawer.Content>
        </Drawer.Popup>
      </Drawer.Root>
    </nav>
  );
};
